/**
 * 接口维护接口
 **/
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class InterfaceMaintainService {

  //基础平台微服务api
  prefix: string = environment.seekerWebAPI;

  //文件处理微服务api
  filefix: string = environment.fileWebAPI;

  //任务调度微服务api
  schedulefix: string = environment.scheduleWebApi;

  constructor(
    private http: SwHttpClientService,
  ) {
  }

 //#region 接口权限接口
 /**
  * 加载接口权限数据
  * @param param
  * @returns {Observable<any>}
  */
 queryControlPageList(param) {
   const url = this.prefix + 'control/queryPageList';
   return this.http.Post(url, param);
 }

 /**
  * 加载接口权限数据
  * @param param
  * @returns {Observable<any>}
  */
 queryByControlId(param) {
  const url = this.prefix + 'control/queryById';
  return this.http.Post(url, param);
}

 /**
  * 新增接口 
  * @param param
  */
 save(param) {
   const url = this.prefix + 'control/save';
   return this.http.Post(url, param);
 }

 /**
  * 修改或更新
  * @param param
  */
 updateById(param) {
   const url = this.prefix + 'control/updateById';
   return this.http.Post(url, param);
 }

 /**
  * 删除
  * @param param
  */
 deleteBatch(param) {
  const url = this.prefix + 'control/deleteBatch';
  return this.http.Post(url, param);
}

 //#endregion

}
